export default function Hero() {
  return (
    <section className="relative bg-[#0F172A] min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2fd9262d0fe9936c90edf56a9faf27a9.jpg"
          alt="AI Infrastructure Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/70 via-[#0F172A]/60 to-[#0F172A]/70"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          Operational Strength.<br />Precision Intelligence.
        </h1>
        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed">
          Atlas AI Services builds AI-driven infrastructure for home service operators and financial firms who demand clarity, control, and measurable performance.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button className="px-8 py-4 bg-white text-[#0F172A] text-base font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            Request Strategy Call
          </button>
          <button className="px-8 py-4 border-2 border-white text-white text-base font-semibold hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
            See How It Works
          </button>
        </div>
        <p className="text-sm text-gray-400 font-medium">
          Engineered systems. Measurable results. Zero fluff.
        </p>
      </div>
    </section>
  );
}